import React, { useState, useEffect, useRef, useCallback, Fragment } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { sendMassSms } from '../../../common/api';
import { toast } from 'react-toastify';
import Handlebars from 'handlebars/dist/cjs/handlebars';
// import 'emoji-mart/css/emoji-mart.css';
import Picker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import ScheduleButton from '../ScheduleButton';
import { useDropzone } from 'react-dropzone';
import { createFile } from '../../../common/api';
import { storeMedia, createId, getMimeTypeFromExtension } from '../../../common/utils';



const SendMassTxt = ( { user, zone, stack, viewing, contacts, close, opps, loans, globalStatus, loanStatus, clist, llist, objType, tmpl, tmplContent } ) => {
    const [ to, setTo ] = useState( [] );
    const [ from, setFrom ] = useState( '' );
    const [ senderList, setSenderList ] = useState( [] );
    const [ body, setBody ] = useState( '' );
    const [ attachments, setAttachments ] = useState( [] );
    const [ recipIdx, setRecipIdx ] = useState( {} );
    const [ pList, setPList ] = useState( [] );
    const [ sending, setSending ] = useState( false );
    const [ tmplUsed, setTmplUsed ] = useState( '' );
    const [ showEmojis, setShowEmojis ] = useState( false );
    const [ allTmpls, setAllTmpls ] = useState( {} );
    const [ bodyRendered, setBodyRendered ] = useState( '' );
    const [ loaded, setLoaded ] = useState( false );
    const [ noSender, setNoSender ] = useState( true );
    
    
    const editorRef = useRef( null );

    const displayContactName = ( cid ) => {
        let name = 'Unknown Name';
        const c = contacts[cid];
        if ( c ) {
            name = c.preferredName || c.firstname;
            if ( c.lastname ) {
                name += ( name?.length ) ? ' ' : '';
                name += c.lastname;
            }
            if ( !name?.length ) {
                name = c.email;
            }
        }
        return name;
    };

    const displayLoanNames = ( lid ) => {
        let name = 'Unknown Name';
        const l = loans[lid];
        if ( l && l.borrowers && l.borrowers.length ) {
            const pri = l.borrowers.find( f => f.label === 'Primary' ) || l.borrowers[0];
            const c = contacts[pri?.cid];
            if ( c ) {
                name = c.preferredName || c.firstname;
                if ( c.lastname ) {
                    name += ( name.length ) ? ' ' : '';
                    name += c.lastname;
                }
                if ( !name.length ) {
                    name = c.email;
                }
            }
        }
        return name;
    };

    const render = ( obj ) => {
        const t = Handlebars.compile( body );
        
        let params = {};

        Handlebars.registerHelper( 'isYes', function ( value ) {
            return ( value === 'Yes' );
        } );
        Handlebars.registerHelper( 'isRefi', function ( value ) {
            return value.match( /refi/i );
        } );
        Handlebars.registerHelper( 'textMatch', function ( a, b ) {
            return ( a === b );
        } );
        Handlebars.registerHelper( 'textMismatch', function ( a, b ) {
            return ( a !== b );
        } );
        Handlebars.registerHelper( 'formatMoney', function ( value ) {
            const sanitizedInput = value.replace( /[\$,]/g, '' );
            const val = parseFloat( sanitizedInput );

            // Check if the value is a number
            if ( isNaN( val ) ) {
                return '';
            }

            // Check if the input has decimal places
            const hasDecimals = ( val % 1 ) !== 0;

            // Create a formatter
            const formatter = new Intl.NumberFormat( 'en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: hasDecimals ? 2 : 0,
                maximumFractionDigits: hasDecimals ? 2 : 0,
            } );

            return formatter.format( val );
        } );
        Handlebars.registerHelper( 'formatPercentage', function ( value ) {
            const sanitizedInput = value.replace(/%/g, '');
            const val = parseFloat( sanitizedInput );

            // Check if the value is a number
            if ( isNaN( val ) ) {
                return '';
            }

            // Check if the input is already a percentage (i.e., it's greater than 1)
            const isDecimal = Math.abs( val ) <= 1;

            // Create a formatter
            const formatter = new Intl.NumberFormat( 'en-US', {
                style: 'percent',
                minimumFractionDigits: 0, // isDecimal ? 3 : 3,
                maximumFractionDigits: 3 // isDecimal ? 3 : 3,
            } );

            return formatter.format( isDecimal ? val : val / 100 );
        } );
        
        if ( objType === 'contact' ) {
            const refs = [];

            if ( obj.priRole === 'partner' ) {
                obj['activeLeads'] = false;
                obj['activePAs'] = false;
                obj['activeLoans'] = false;

                Object.keys( contacts ).forEach( cid => {
                    const c = contacts[cid];
                    if ( c.referredById === obj.cid ) {
                        console.log( c.name + ' is referred by ' + obj.name );
                        const los = [];
                        const ls = [];

                        Object.keys( opps ).forEach( o => {
                            const lo = opps[o];
                            if ( lo.relationships.find( f => f.cid === c.cid ) ) {
                                const q = globalStatus.find( f => f.value === lo.status );

                                if ( [ 'lead', 'talking', 'app-sent', 'setup', 'review' ].includes( q?.queue ) ) {
                                    obj['activeLeads'] = true;
                                    lo['queue'] = 'lead';
                                    los.push( lo );
                                }
                            }
                        } );

                        Object.keys( loans ).forEach( lid => {
                            const l = loans[lid];
                            if ( l.borrowers.find( f => f.cid === c.cid ) ) {
                                const q = loanStatus.find( f => f.value === l.status );

                                if ( q?.queue === 'pa' ) {
                                    obj['activePAs'] = true;
                                    l['queue'] = 'pa';
                                    ls.push( l );
                                }

                                if ( q?.queue === 'active' ) {
                                    obj['activeLoans'] = true;
                                    l['queue'] = 'active';
                                    ls.push( l );
                                }
                            }
                        } );

                        refs.push( {
                            ...c,
                            opps: los,
                            loans: ls
                        } );
                    }
                } );
            }

            params['contact'] = {
                ...obj,
                referredBy: contacts[obj.referredById],
                referrals: refs
            };

            console.log( 'params: ', params );
        } else if ( objType === 'loan' ) {
            const pri = obj.borrowers.find( f => f.label === 'Primary' );
            const c = contacts[pri.cid];
            console.log( 'u: ', user );
            const lp2 = user.lists.team.find( f => f.uid === obj.lp2 );
            params['contact'] = {
                ...c,
                referredBy: contacts[c.referredById]
            };
            params['loan'] = {
                ...obj,
                buyersAgent: contacts[obj.baId],
                buyersAgentTC: contacts[obj.baTcId],
                listingAgent: contacts[obj.laId],
                listingAgentTC: contacts[obj.laTcId],
                escrow: contacts[obj.escrowOfficerId],
                title: contacts[obj.titleRepId],
                lp2rep: lp2
            };
        }
        setBodyRendered( t( {
            ...params,
            user: user
        } ) );
    }

    const addEmoji = ( e ) => {
        let emoji = e.native;
        setBody( prev => prev + emoji );
        setShowEmojis( false );
        if ( editorRef ) {
            editorRef.current.focus();
        }
    }

    const switchSender = ( from ) => {
        setFrom( from );
    };

    const onDrop = useCallback( acceptedFiles => {
        for ( let i = 0; i < acceptedFiles.length; i++ ) {
            const f = acceptedFiles[i];
            const reader = new FileReader();
            
            reader.onabort = () => {
                toast.success( `The upload process on ${f.path} has been aborted`, { theme: 'dark' } );
            }
            reader.onerror = () => {
                toast.success( `There's been an error while uploading ${f.path}`, { theme: 'dark' } );
            }
            reader.onload = async () => {
                const b = new Blob( [ reader.result ] );
                const ext = f.name.split( /(?:\.([^.]+))?$/ )[1];
                let n = createId( 'file' );
                if ( ext ) {
                    n += '.' + ext;
                }
                const name = await storeMedia( user.aid, user.email, n, b, getMimeTypeFromExtension( ext ) );
                
                let file = {
                    mediaUrl: name,
                    name: f.name
                }
                
                await createFile( user.aid, user.email, file );

                setAttachments( prev => [
                    ...prev,
                    { name: file.name, fid: file.mediaUrl }
                ] );
                // toast.success( `Successfully uploaded ${f.name}`, { theme: 'dark' } );
                console.log( 'uploaded: ', name );
            }
            reader.readAsArrayBuffer( f );
        }
    }, [ user.aid, user.email ] );

    const { getRootProps, getInputProps, isDragActive } = useDropzone( { onDrop } );

    const removeAttachment = ( file ) => {
        setAttachments( prev => {
            const list = prev.filter( f => f.name !== file );
            return [ ...list ];
        } );
    }

    const send = async ( d, t, tz ) => {
        setSending( true );
        const now = new Date();

        if ( !d ) {
            var dd = String( now.getDate() ).padStart( 2, '0' );
            var mm = String( now.getMonth() + 1 ).padStart( 2, '0' ); //January is 0!
            d = now.getFullYear() + '-' + mm + '-' + dd;
        }
        if ( !t ) {
            t = now.getHours() + ':' + now.getMinutes();
        }
        if ( !tz ) {
            tz = zone;
        }

        const msg = {
            body: body,
            tmpl: tmplUsed,
            attachments: attachments,
            date: d,
            time: t,
            tz: tz,
            channel: 'sms'
        };

        if ( from && from.length ) {
            msg['from'] = from;
        }
        
        if ( objType === 'loan' ) {
            msg['loans'] = llist;
        } else if ( objType === 'contact' ) {
            msg['contacts'] = clist;
        } else {
            console.log( 'unknown objType: ' + objType );
        }

        console.log( 'msg: ', msg );
        
        const s = senderList.find( f => f.number === from );
        const sent = await sendMassSms( s.aid, user.email, msg );
        console.log( 'sent resp: ', sent );
        // if ( sent.length ) {
            setSending( false );
            toast.success( `The Text has been Sent`, { theme: 'dark' } );
            close();
        // }
        // console.log( sent );
    };

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '750px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };
    
    useEffect( () => {
        if ( from && from.length ) {
            setNoSender( false );
        } else {
            setNoSender( true );
        }
    }, [ from ] );

    useEffect( () => {
        if ( tmplContent && tmplContent.length ) {
            setBody( tmplContent );
        } else if ( tmpl ) {
            let t;

            if ( user.templates && user.templates.length ) {
                t = user.templates.find( f => f.tid === tmpl );
            }

            if ( !t && user.meta.templates && user.meta.templates.length ) {
                t = user.meta.templates.find( f => f.tid === tmpl );
            }

            if ( t ) {
                setBody( t.body );
                setTmplUsed( t.tid );
            }
        }
    }, [ tmplContent, tmpl, user.aid, user.templates, user.meta.templates ] );
    
    useEffect( () => {
        let temps = {};

        if ( user.meta.templates && user.meta.templates.length ) {
            user.meta.templates.forEach( t => {
                temps[t.tid] = t;
            } );
        }
        if ( user.templates && user.templates.length ) {
            user.templates.forEach( t => {
                temps[t.tid] = t;
            } );
        }

        setAllTmpls( temps );
    }, [ user.templates, user.meta.templates ] );

    useEffect( () => {
        if ( clist?.length && !loaded ) {
            setLoaded( true );
            setTo( clist );
        }
    }, [ clist, loaded ] );

    useEffect( () => {
        let list = [];
        if ( user.additionalAccounts ) {
            for ( let i = 0; i < viewing.length; i++ ) {
                const a = user.additionalAccounts.find( f => f.aid === viewing[i] );
                if ( a && a.sms ) {
                    list.push( { aid: a.aid, label: a.aid, number: a.sms } );
                    if ( typeof( a.sms ) === 'string' ) {
                        list.push( { label: a.aid, number: a.sms, aid: a.aid } );
                    } else {
                        for ( const s of a.sms ) {
                            list.push( { label: `${a.aid} - ${s.label}`, number: s.number, aid: a.aid } );
                        }
                    }
                }
            }
        } else if ( stack.sms && stack.sms.phones && stack.sms.phones.length ) {
            stack.sms.phones.forEach( p => list.push( { aid: user.aid, label: p.label, number: p.number } ) );
        } else if ( stack.sms && stack.sms.phone ) {
            list.push( { aid: user.aid, label: user.aid, number: stack.sms.phone } );
        }

        setSenderList( list );
        if ( list.length === 1 ) {
            setFrom( list[0].number );
        }
    }, [ user, stack.sms, viewing ] );

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Send a Txt</Col>
                </Row>
                <Row className='pt-3'>
                    <Col>
                        <Form.Group as={Row} className='tf-form-group align-items-center px-3 pb-3 tf-email-header-row'>
                            <Form.Label column xs='auto' className='col-md-auto p-0 fw-light'>From</Form.Label>
                            {
                                ( senderList.length === 1 ) ? (
                                    <Col className='tf-email-header-value'>{from}</Col>
                                ) : (
                                    <Col xs='auto' className='tf-email-header-value tf-form-select-field me-1'>
                                        <Form.Select size='sm' className='tf-modal-select-input' value={from} onChange={ ( e ) => switchSender( e.target.value ) }>
                                            <option value=''>Choose a Sender</option>
                                            {
                                                senderList.map( ( s, idx ) => <option key={`sender-${idx}`} value={s.number}>{s.label} - {s.number}</option> )
                                            }
                                        </Form.Select>
                                    </Col>
                                )
                            }
                        </Form.Group>
                    </Col>
                </Row>
                <Tabs defaultActiveKey='content'>
                    <Tab eventKey='content' title='Content'>
                        <Row className='pt-3'>
                            <Col>
                                <Row className='tf-sms-editor-header'>
                                    <Col>
                                        <Button onClick={ () => setShowEmojis( prev => !prev ) } variant='link'><InsertEmoticonIcon /></Button>
                                        { showEmojis ? <Picker data={data} onEmojiSelect={ addEmoji } /> : null }
                                    </Col>
                                </Row>
                                <Row className='tf-sms-editor-body'>
                                    <Col className='py-2'>
                                        <textarea className='tf-sms-editor-ta' 
                                            ref={ editorRef }
                                            value={ body } 
                                            onChange={ ( e ) => setBody( e.target.value ) } 
                                            placeholder="Type your message here..."
                                        />
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Tab>
                    <Tab eventKey='preview' title='Preview'>
                        <Container fluid className='px-0'>
                            <Row className='tf-email-editor-container me-0'>
                                <Col xs={3} className='overflow-scroll' style={ { borderRight: '1px solid #CCC', maxHeight: '400px' } }>
                                    {
                                            clist && clist.length ? clist.map( cid => {
                                                return (
                                                    <Row key={cid}>
                                                        <Col><Button size='sm' variant='link' onClick={ () => render( contacts[cid] ) }>{displayContactName( cid )}</Button></Col>
                                                    </Row>
                                                )
                                            } ) : null
                                        }
                                        {
                                            llist && llist.length ? llist.map( lid => {
                                                return (
                                                    <Row key={lid}>
                                                        <Col><Button size='sm' variant='link' onClick={ () => render( loans[lid] ) }>{displayLoanNames( lid )}</Button></Col>
                                                    </Row>
                                                )
                                            } ) : null
                                        }
                                </Col>
                                <Col xs={9} className='overflow-scroll pt-2' style={ { maxHeight: '400px' } }>
                                    <div dangerouslySetInnerHTML={ { __html: bodyRendered } } />
                                </Col>
                            </Row>
                        </Container>
                    </Tab>
                </Tabs>
                {
                    attachments.length ? (
                        <Container fluid className='pe-0'>
                            <Row className='w-100 py-2 me-0'>
                                { attachments.map( a => <Col key={a.name} xs='auto'><span className='tf-email-attachment-file'>{a.name}</span><span className='tf-email-attachment-delete' onClick={ () => removeAttachment( a.name ) }>X</span></Col>) }
                            </Row>
                        </Container>
                    ) : (
                        null
                    )
                }
                <Container fluid className='pe-0'>
                    <Row className='w-100 py-2 me-0 align-items-center'>
                        <Col className='p-2 text-center' { ...getRootProps() } style={ { color: 'var( --tf-blue )', fontWeight: 600, border: '1px dotted var( --tf-blue )' } }>
                            <input { ...getInputProps() } />
                            <Row><Col>Drop Attachments or <Button variant='outline-primary' size='sm'>Select Files</Button></Col></Row>
                        </Col>
                    </Row>
                </Container>
                <Container fluid>
                    <Row className='w-100 p-2 align-items-center'>
                        <Col className='pe-2 text-end'><ScheduleButton send={send} disabled={sending || noSender} /></Col>
                        <Col className='ps-2 text-start'><Button variant='outline-dark' onClick={close}>Cancel</Button></Col>
                    </Row>
                </Container>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    user: state.user,
    stack: state.user.stack,
    zone: state.user.tz,
    viewing: state.user.viewing,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    loans: state.loans.byId,
    globalStatus: state.user.meta.global.picklist.status,
    loanStatus: state.user.meta.loan.picklist.status,
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( SendMassTxt );